import { isExcludedFn } from "../api/issb/Question";

/**
 * Why Submit or Approve is not offered for a question right now, or null when it is.
 *
 * Both need saved edits, and something to submit. What counts as "something" is normally the answer text or an
 * attached file — but a Foundation Data v2 workstream keeps its content as FIGURES, in their own table, and its
 * `answer` holds only the optional Additional Information notes. So a workstream full of figures read as empty and
 * could not be submitted at all (ESG-4021). `hasContent`, when the caller passes it, replaces the answer-or-files
 * test; left undefined, the rule is exactly what every other AIR question has always had. The server enforces no
 * such rule — this is the only gate.
 *
 * A standalone file because the `src/utils` barrel contains JSX and breaks vitest imports.
 *
 * @param {string} actionType SUBMIT, APPROVE, REJECT, …
 * @param {{question?: object, answerModified?: boolean, hasContent?: boolean}} state
 * @returns {string|null}
 */
export function actionDisabledReason(actionType, { question, answerModified = false, hasContent } = {}) {
  if (actionType !== "SUBMIT" && actionType !== "APPROVE") return null;
  if (answerModified) return "The question has unsaved edits";
  const hasSomething =
    hasContent !== undefined ? hasContent : !!question?.answer || !!question?.files?.length;
  if (!hasSomething && !isExcludedFn(question)) {
    return hasContent !== undefined ? "There is no data to submit yet" : "The question has no answer";
  }
  return null;
}
